module.exports = __webpack_public_path__ + "img/login.c1486231.png";